module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19nG4EG/images/Cover.jpg?1722447452808",
      "alt": "This image is the cover for the book Adventure Time #13, Adventure Time"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Adventure Time #13, Adventure Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Finn, Jake, and Marceline, on the hunt for Ewlbo—the wizard who gave BMO a computer virus—race to find out the truth before BMO’s gone for good. Can Marceline’s totally radical hacking skills save the day? Or is something about to go very wrong?! Also featuring the backup stories “The Devilish Devourer of Delicious Delicacies” and “Princess of Rad Hats (Part One)”!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ryan North, Shelli Paroline, Braden Lamb, Steve Wands, Pendleton Ward\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ryan North's recent work includes the nonfiction books How To Take Over The World and How To Invent Everything, the semi-fictional graphic novel adaptation of Kurt Vonnegut's Slaughterhouse-Five, and the so-far-fictional Unbeatable Squirrel Girl series for Marvel. He's a multiple New York Times bestseller whose work has been translated into 16 different languages to date, and as a linguist, he's very happy about that. He lives in Toronto, where he once messed up walking his dog so badly it made the news.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ONI Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0